module.exports = __webpack_public_path__ + "img/Safebox.b5d21241.png";